import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=633e6d59"
import script from "./TermsPage.vue?vue&type=script&lang=js"
export * from "./TermsPage.vue?vue&type=script&lang=js"
import style0 from "./TermsPage.vue?vue&type=style&index=0&id=633e6d59&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports